import clsx from "clsx";
import { forwardRef } from "react";

import classes from "./styles.module.scss";

import { Icon } from "@components/atoms/icons";
import { useMaxMedia } from "@utils";
import { IBreakpointsEnum } from "@constants";
import type { IActionButtonProps } from "@components/organisms/videoVisit";
import { SettingButton } from "@components/organisms/videoVisit/components/settingButton";

export const ActionButton = forwardRef<HTMLDivElement, IActionButtonProps>(
  (
    {
      icon,
      onClick,
      isSelected,
      settingProps,
      lineThrough,
      isDanger,
    }: IActionButtonProps,
    ref,
  ) => {
    const media = useMaxMedia(IBreakpointsEnum.XS);

    return (
      <div className={clsx(classes.buttonsPlace)} ref={ref}>
        <div
          className={clsx(
            classes.actionButton,
            isSelected && classes.actionButton__selected,
            isDanger && classes.danger,
          )}
          onClick={() => onClick?.()}
        >
          {!isSelected && lineThrough && (
            <div className={clsx(classes.actionButton__lineThroug)} />
          )}
          <Icon
            name={icon}
            color={isSelected || isDanger ? "white" : "primary-text"}
            fontSize={media ? "lg" : "2xl"}
            type={isSelected ? "bold" : "outline"}
          />
        </div>
        {settingProps && (
          <div
            className={clsx(classes.actionButton__settings)}
            onClick={(event) => event.stopPropagation()}
          >
            <SettingButton {...settingProps} />
          </div>
        )}
      </div>
    );
  },
);

ActionButton.displayName = "ActionButton";
